// @ts-nocheck
import React from 'react';
import { InfoBanner } from '../components/WorkflowFormPrimitives';
import { WorkspaceLoadingCard } from '../../shared/WorkspaceLoadingCard';
import RunHistoryRunsTable from './RunHistoryRunsTable';
import type { RunHistoryTableRow } from './runHistoryTableModel';

/**
 * Search + loading/empty states + {@link RunHistoryRunsTable} — shared client run history page and firm historical runs tab.
 */
export function RunHistoryPanel({
  error,
  loading,
  totalRowCount,
  searchQuery,
  onSearchChange,
  searchInputId = 'run-history-search',
  displayRows,
  onViewSnapshot,
  emptyState,
  linkAnalysisNames = false,
  onClientAnalysisNameClick,
  analysisNameSubline = null,
  showAnalysisNameLock = false,
  analysisNameLocked = false,
  loadingCardCompact = false,
}: {
  error?: string | null;
  loading?: boolean;
  totalRowCount: number;
  searchQuery: string;
  onSearchChange: (q: string) => void;
  searchInputId?: string;
  displayRows: RunHistoryTableRow[];
  onViewSnapshot: (row: RunHistoryTableRow) => void;
  emptyState: React.ReactNode;
  /** Client `/client/run-history` only — matches Analyses list name links. */
  linkAnalysisNames?: boolean;
  onClientAnalysisNameClick?: (analysisId: string) => void;
  analysisNameSubline?: { createdBy?: string; createdOn?: string } | null;
  showAnalysisNameLock?: boolean;
  analysisNameLocked?: boolean;
  /** Nested firm tab: shorter loading card. */
  loadingCardCompact?: boolean;
}) {
  return (
    <div className="space-y-5">
      {error ? (
        <InfoBanner variant="danger" showIcon>
          {error}
        </InfoBanner>
      ) : null}

      {loading ? (
        <WorkspaceLoadingCard
          compact={loadingCardCompact}
          title="Loading run history…"
          description="Fetching stored runs for this analysis."
          ariaLabel="Loading analysis run history"
        />
      ) : null}

      {!loading && totalRowCount === 0 ? emptyState : null}

      {!loading && totalRowCount > 0 ? (
        <RunHistoryRunsTable
          rows={displayRows}
          onViewSnapshot={onViewSnapshot}
          linkAnalysisNames={linkAnalysisNames}
          onClientAnalysisNameClick={onClientAnalysisNameClick}
          analysisNameSubline={analysisNameSubline}
          showAnalysisNameLock={showAnalysisNameLock}
          analysisNameLocked={analysisNameLocked}
          searchToolbar={{
            value: searchQuery,
            onChange: onSearchChange,
            inputId: searchInputId,
          }}
        />
      ) : null}
    </div>
  );
}
